import React, { useState } from "react";
import moment from 'moment';
import axios from 'axios';
import { FaWhatsapp } from 'react-icons/fa';
import { FaInstagram } from 'react-icons/fa';
import { FaFacebookMessenger } from 'react-icons/fa';


function HikeDisplay({ hikes = [], loadMore, hasMore, loading, isAdmin= false, fetchHikes, allViewHikesLength }) {

  const [zoomedTripId, setZoomedTripId] = useState(null);
  const [showContact, setShowContact] = useState({});
  const [showDescription, setShowDescription] = useState({})

  
    const toggleZoom = (id) => {
      setZoomedTripId(zoomedTripId === id ? null : id);
    };

     const handleOutsideClick = (e) => {
    if (e.target.classList.contains('zoomedOverlay')) {
      setZoomedTripId(null);
    }
  };


   const handleDeleteHike = async (id) => {
    const del = await axios.delete(`${process.env.REACT_APP_API_URL}/admin-api/delete/hike/${id}`, { withCredentials: true });
    if (del.data.success) {
      fetchHikes();
      alert(del.data.message);
    }
  };


  return(
    <>
          { hikes.map((hike) => {
            
                const dateStart = moment(hike.dateStartHike).format('DD-MM-YYYY');
                const timeStartHike = hike.timeStartHike ? moment(hike.timeStartHike, "HH:mm").format("HH:mm") : null;
        
                return (
        
                  <div className="tripContainer userSelectNone"  key={hike.id}>
                    
                    <section className='section-one'>
        
                      <div className="trip-route">
                          <span className="trip-city">
                           {hike.startPoint ?  
                           <>📍 {hike.startPoint}<span style={{marginRight: '10px'}} className="arrow">→</span></>: null  }
                           {hike.destination} 🏔️
                          </span>
                      </div>
        
                    </section>
        
                    <section className='section-two'>
        
                      {!isAdmin && (
                        <div className="user">
                          
                          <div className="userImageWrapper" onClick={() => toggleZoom(hike.id)}>
                            <img
                              src={
                                hike.imgPath
                                ? hike.imgPath.replace('/upload/', '/upload/w_400,f_auto,q_auto/')
                                : '/placeholder.png'
                              }
                              alt={hike.userName}
                              className="userImage"
                              loading="lazy"
                            />
                          </div>
        
                          <p className="userName">{hike.userName}</p>
        
                          {zoomedTripId === hike.id && (
                            <div className="zoomedOverlay" onClick={handleOutsideClick}>
                              <div
                                className="zoomedImage"
                                style={{ 
                                  backgroundImage: 
                                  `url(${hike.imgPath?hike.imgPath.replace('/upload/', '/upload/w_1200,f_auto,q_auto/'):'/placeholder.png'})`,
                                  }}
                                onClick={(e) => e.stopPropagation()}
                              ></div>
                            </div>
                          )}
                        </div>
                      )}

                                  
        
                      <div className="trip-dates">
                        <p>🗓️ <strong>Data Wyjśćia:</strong> {dateStart}</p>
                        <p>🗓️ <strong>Przewidywana godzina:</strong> { timeStartHike ? timeStartHike: 'brak' }</p>
                      </div>

        
                    </section>
        
                    <section className='section-three'>

                      <p className="speed">⚡ <strong>Tępo:</strong> {hike.speed}</p> 
                            
                      <div className='contactSection'>
        
                        <p
                          className="toggle-contact"
                          onClick={() =>
                            setShowContact(prev => ({
                              ...prev,
                              [hike.id]: !prev[hike.id],
                            }))
                          }
                        >   
                          {showContact[hike.id] ? 
                          <span>
                            <strong>🔗 Kontakt </strong> <span className='btnShowHideTxt'> zwiń ▲</span> 
                          </span> 
                          : 
                          <span>
                            <strong>🔗 Kontakt </strong> <span className='btnShowHideTxt'> rozwiń ▼ </span>
                          </span> 
                          }
                        </p>
        
                        <div className={`trip-contact ${showContact[hike.id] ? 'show' : ''}`}>
                          {hike.contactPhone && <p><span><FaWhatsapp color="#25D366" size={18} /> </span><strong>{hike.contactPhone}</strong></p>}
                          {hike.contactInsta && <p><span><FaInstagram color="#E1306C" size={18} /></span><strong>@{hike.contactInsta.replace(/^@/, '')}</strong></p>}
                          {hike.contactMessenger && 
                          <p>
                              <span>
                                <FaFacebookMessenger color="#00B2FF" size={18} /> 
                              </span>
                              <strong>{hike.contactMessenger}</strong>
                          </p>}
                        </div>
        
                      </div>
        
                      <div className="trip-description-inline">
        
                        <p
                          className="toggle-description"
                          onClick={() =>
                            setShowDescription(prev => ({
                              ...prev,
                              [hike.id]: !prev[hike.id],
                            }))
                          }
                        >
                          { hike.description ? (
                          <>
                          {showDescription[hike.id] ? 
                          <span>
                            <strong>📝 Opis wyjścia </strong> <span className='btnShowHideTxt'>zwiń ▲</span>
                          </span>  
                          : 
                          <span>
                            <strong>📝 Opis wyjścia </strong> <span className='btnShowHideTxt'>rozwiń ▼</span>
                          </span>
                          }</>
                        ):(<>
                        <span>
                            <strong>📝 Opis wyjścia </strong> <span className='btnShowHideTxt'>brak</span>
                          </span>
                        </>)}
                        </p>
                        
                        <div className={`description ${showDescription[hike.id] ? 'show' : ''}`}>
                          {hike.description}
                        </div> 
        
                      </div>
        
                    </section>
        
                    {isAdmin && <button onClick={()=>handleDeleteHike(hike.id)}>Usuń przejazd</button>}
                  
                  </div>
                );
              })}

              {allViewHikesLength ? null : <p className="userSelectNone"  style={{marginTop: '10vh'}}>Brak wypraw</p>}

              {!isAdmin && !loading && hasMore && hikes.length > 0 && (
                <div className="load-more-wrapper" style={{ marginTop: '20px' }}>
                  <button className="btn load-more-btn userSelectNone" onClick={loadMore}>
                    Pokaż więcej
                  </button>
                </div>
              )}
    </>
  )

}

export default HikeDisplay